import React from 'react';
import { Helmet } from 'react-helmet-async';

import { ShopApi } from '../data/ShopApi';

import './Shop.scss';
import { Route } from 'react-router-dom';
import ShopProductList from './ShopProductList';
import { Header } from '../components/Header';

type ShopState = {
  addedToCart: number;
  slowActionPending: boolean;
};

class Shop extends React.Component<{}> {
  state: ShopState = {
    addedToCart: 0,
    slowActionPending: false,
  };
  private readonly shopApi: ShopApi = new ShopApi('https://www.whoisnemos.com/wp-shop/wp-json');

  render() {
    return (
      <>
        <Helmet>
          <title>Shop - Who Is NemO'S?</title>
          <meta name="theme-color" content="#faf4ef" />
        </Helmet>
        <Route sensitive exact path="/shop/cart">
          <Header backLink="/shop" page="shop" addedToCart={this.state.addedToCart} />
          <div className="page-content shop with-frame">
            {/* TODO: remove URL */}
            <iframe
              id="shopFrame"
              name="shopFrame"
              title="Shop"
              src="https://www.whoisnemos.com/wp-shop/cart/"
            ></iframe>
          </div>
        </Route>
        <Route sensitive exact path="/shop">
          <Header backLink="/" page="shop" addedToCart={this.state.addedToCart} />
          <div
            className={[
              'page-content',
              'shop',
              this.state.slowActionPending ? 'disabled' : '',
            ].join(' ')}
          >
            <ShopProductList addToCart={(productId: number) => this.addToCart(productId)} />
          </div>
          {this.state.slowActionPending ? (
            <div className="loader-container">
              <div className="loader" />
            </div>
          ) : (
            ''
          )}
        </Route>
      </>
    );
  }

  async componentDidMount() {
    this.setState({
      addedToCart: await this.shopApi.getCartSize(),
    });
  }

  async addToCart(productId: number) {
    this.setState({
      slowActionPending: true,
    });
    this.setState({
      slowActionPending: false,
      addedToCart: await this.shopApi.addToCart(productId),
    });
  }
}

export default Shop;
